/**
 * Converts a relative URL path to an absolute URL for BI tracking.
 * If the URL is already absolute, returns it unchanged.
 *
 * @param path - The relative or absolute URL path (string or Url type)
 * @returns The absolute URL
 */
export const toAbsoluteUrl = (path: string | any): string | undefined => {
  if (!path) {
    return path;
  }

  // Convert to string if it's not already (handles Url type from BI logger)
  const pathStr = String(path);

  try {
    // If already absolute, return as-is
    if (pathStr.startsWith('http://') || pathStr.startsWith('https://')) {
      return pathStr;
    }

    // Convert relative path to absolute
    return new URL(pathStr, window.location.origin).href;
  } catch (error) {
    // Fallback if URL construction fails
    console.warn('Failed to convert to absolute URL:', pathStr, error);
    return pathStr;
  }
};
